import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemKeepsReturning() {
  const commonSituations = ['The check engine light came back after a repair', "Parts were replaced but the problem didn't go away", 'A shop suggested "trying another part next"', 'The issue disappears and returns randomly', 'Multiple warning lights appear at the same time'];
  return <section className="py-20 px-4 bg-brand-light space-y-[6px] pt-[1px] pb-[1px]" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        {/* Part 1: When the problem keeps coming back */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-10 pt-[50px] pb-[50px]" data-id="element-132">
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-8 text-center" data-id="element-133">
            If this sounds familiar
          </h2>

          <p className="text-xl text-gray-700 mb-8 text-center" data-id="element-134">
            Many drivers come to Lancer after trying to fix a problem somewhere
            else first.
          </p>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 mb-10" data-id="element-135">
            <p className="font-bold text-brand-dark text-lg mb-6" data-id="element-136">
              Common situations include:
            </p>
            <ul className="space-y-4" data-id="element-137">
              {commonSituations.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-138">
                  <AlertCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-139" />
                  <span className="text-lg text-gray-700" data-id="element-140">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center space-y-3" data-id="element-141">
            <p className="text-xl text-brand-dark font-medium" data-id="element-142">
              At that point, the problem usually isn't the part that was
              replaced.
            </p>
            <p className="text-xl text-brand-dark font-bold" data-id="element-143">
              It's that the original diagnosis never confirmed the real cause.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}